<nav class="navbar navbar-expand-md navbar-dark bg-primary">
  <a class="navbar-brand" href="#">{{ 'title' | translate }}</a>
</nav>

<div class="container text-center">
  <h1 class="mt-4">{{ 'not-found.title' | translate }}</h1>
  <p>{{ 'not-found.text' | translate }}</p>
  <button class="btn btn-light" [routerLink]="['/']">{{ 'not-found.home-button' | translate }}</button>
</div>